
    require(
      "!../../node_modules/gatsby/dist/loaders/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { 
     return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/babel-loader/lib/index.js?{\"plugins\":[\"/opt/build/repo/node_modules/gatsby/dist/utils/babel-plugin-extract-graphql.js\"]}!../../node_modules/ts-loader/index.js?{\"compilerOptions\":{\"target\":\"esnext\",\"removeComments\":true,\"emitDecoratorMetadata\":true,\"experimentalDecorators\":true,\"jsx\":\"preserve\",\"sourceMap\":true,\"strictNullChecks\":true,\"lib\":[\"es7\",\"dom\"],\"allowJs\":true,\"noUnusedLocals\":true,\"types\":[\"@types/node\"]},\"logLevel\":\"warn\",\"exclude\":[\"node_modules\",\"dist\",\".cache\"]}!./404.tsx") })
        }
      }, "page-component---src-pages-404-tsx");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby/dist/loaders/gatsby-module-loader?name=page-component---src-pages-404-tsx!./src/pages/404.tsx
// module id = ./node_modules/gatsby/dist/loaders/gatsby-module-loader/index.js?name=page-component---src-pages-404-tsx!./src/pages/404.tsx
// module chunks = 154